import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportSalesService extends GenericService {
    constructor() {
        super('/reports/sales', axiosInstance);
    }
}

export default new ReportSalesService();